import icAi from "@/assets/icAi.svg";
import icBack from "@/assets/icBack.svg";
import icM from "@/assets/icM.svg";
import icSend from "@/assets/icSend.svg";
import icSendDisabled from "@/assets/icSendDisabled.svg";
import icArrowLeft from "@/assets/icArrowLeft.svg";
import icDrop from "@/assets/icDrop.svg";
import icBackGreen from "@/assets/icBackGreen.svg";
import icMailFilled from "@/assets/icMailF.svg";
import icWeb from "@/assets/icWeb.svg";
import icLogo from "@/assets/vite.svg";
import bgLogin from "@/assets/bgLogin.png";
import icApple from "@/assets/icApple.svg";
import icGoogle from "@/assets/icGoogle.svg";
import icMail2 from "@/assets/icMail2.svg";
import icBack2 from "@/assets/icBack2.svg";
import icLogoAds from "@/assets/icLogoAds.svg";
import icLogoAds2 from "@/assets/icLogoAds2.svg";
import icDelete from "@/assets/icDelete.svg";
import icAbout from "@/assets/icAbout.svg";
import icLink from "@/assets/icLink.svg";
import icLogout from "@/assets/icLogout.svg";
import icSearch from "@/assets/icSearch.svg";
import icAppstore from "@/assets/icAppStore.png";
import icGooglePlay from "@/assets/icGooglePlay.png";
import icQr from "@/assets/icQr.png";
import icInfo from "@/assets/icInfo.svg";
import icClose from "@/assets/icClose.svg";

export const ASSETS = {
	icAi,
	icBack,
	icM,
	icSend,
	icSendDisabled,
	icArrowLeft,
	icDrop,
	icBackGreen,
	icMailFilled,
	icWeb,
	icLogo,
	bgLogin,
	icApple,
	icGoogle,
	icMail2,
	icBack2,
	icLogoAds,
	icLogoAds2,
	icDelete,
	icAbout,
	icLink,
	icLogout,
	icSearch,
	icAppstore,
	icGooglePlay,
	icQr,
	icInfo,
	icClose,
};
